var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 0.575001L8.375 5.5625H11.8125C12.3312 5.5625 12.75 5.98125 12.75 6.5C12.75 7.01875 12.3312 7.4375 11.8125 7.4375H8.375L5.4375 12.425C5.325 12.625 5.10625 12.75 4.875 12.75C4.4375 12.75 4.125 12.3313 4.24375 11.9125L5.55625 7.4375L2.125 7.4375L1.28125 8.85C1.225 8.94375 1.11875 9 1.0125 9H0.7H0.65C0.443749 9 0.29375 8.80625 0.34375 8.6125L0.799999 6.7875L0.875 6.5L0.81875 6.2625L0.75 6L0.45 4.8125L0.34375 4.39375C0.29375 4.19375 0.443749 4.00625 0.65 4.00625H0.88125H1.0125C1.125 4.00625 1.225 4.0625 1.28125 4.15625L2.125 5.5625L5.5625 5.5625L4.25 1.0875C4.125 0.66875 4.4375 0.25 4.875 0.25C5.10625 0.25 5.325 0.375 5.4375 0.575001Z",
    fill: "#223E7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.7a469fb3345ac3be3244cc66675e8841.svg";
export { ForwardRef as ReactComponent };